<script setup lang="ts">

</script>

<template>
    <div class="w-18 rounded-full font-bold text-mono-white text-h6m md:text-h6 bg-red flex items-center gap-0.5 justify-center py-2">
        <svg class="w-4 h-4" viewBox="0 0 17 17" fill="currentColor">
            <use xlink:href="#icon-on-air"></use>
        </svg>
        <span>On Air</span>
    </div>
</template>
